module.exports = __webpack_public_path__ + "static/media/pulverizador.d7093e6e.svg";